<div class="d-flex position-relative justify-content-center">
  <a><img class="close-icon link" (click)="emitFalse()" src="../../../../../../assets/icons/clear-icon.svg" /></a>
  <h2 class="text-center font-weight-bold">Share with others</h2>
</div>
<div class="d-flex justify-content-center button-container w-100">
  <app-shared-buttons [shareLink]="shareLink" [linkTitle]="linkTitle" (shareClicked)="onShareClicked($event)"></app-shared-buttons>
</div>
